/* eslint-disable import/no-anonymous-default-export */
import { Button, Form, notification, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import { AxiosError } from "axios";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import MainLayout from "../../common/components/MainLayout";
import useLoteConsultaAPI from "../useLoteConsultaAPI";

const UploadContainer = styled.div`
  height: 100px;
  background: white;
  align-items: center;
  justify-content: center;
  display: flex;
  font-weight: 600;

  &::before {
    content: "";
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    /* width: calc(100% - 1rem); */
    /* height: calc(100% - 1rem); */
    border: 2px dashed;
    bottom: 0.5rem;
    right: 0.5rem;
  }

  input {
    z-index: 2;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
`;

export default () => {
  const api = useLoteConsultaAPI();
  const [file, setFile] = useState<File | undefined | null>();
  const [loading, setLoading] = useState(false);
  const [modoCarga, setModoCarga] = useState<number | null | undefined>(0);
  const [form] = useForm();
  const inputRef = useRef<HTMLInputElement>(null);
  const [proveedoresConsultaResponse, setProveedoresConsultaResponse] = useState<{ id: string, nombre: string }[]>([])
  const [tipoProveedor, setTipoProveedor] = useState<string>();

  const sendQuery = async () => {
    setLoading(true);
    const response =
      modoCarga === 0
        ? await api.loadQueriedData(file!, tipoProveedor!)
        : await api.loadConsultaRevisada(file!);
    setLoading(false);

    if (response.error && response.error.response.status) {
      const error = response.error as AxiosError;

      notification.error({
        message: [400, 404].includes(error.response?.status ?? 0)
          ? error.response?.data
          : "Error al cargar los datos",
      });
    } else if (response.error) {
      notification.error({ message: "Error al cargar los datos", duration: 5 });
    } else {
      notification.success({ message: "Datos cargados correctamente",duration: 5 });
    }

    setFile(undefined);
    form.resetFields();
    inputRef.current!.value = "";
  };

  const getAcceptedExtensions = () => {
    switch (modoCarga) {
      case 1:
        return [".csv"];
      case 0:
        return [".csv",".xlsx"]
      default:
        return [".xlsx"];
    }
  };

  const getProveedores = async () => {
    const response = await api.queryProvedoresConsulta();
    if (response.error) {
      notification.error({
          message: "Error al listar los proveedores de consulta"
      })
      return;
    }
    setProveedoresConsultaResponse(response.data!.value.map((c : any) => ({ id: c.id, nombre: c.nombre })));
  }

  useEffect(() => {
    getProveedores();
  }, []);

  return (
    <MainLayout title="Cargar consulta">
      <Form form={form} layout="vertical" onFinish={sendQuery}>
        <Form.Item required label="Modo de carga" rules={[{ required: true }]}>
          <Select
            style={{ width: "250px" }}
            placeholder="Seleccione un modo de carga..."
            onChange={(value) => setModoCarga(value)}
            value={modoCarga}
          >
            <Select.Option value={0}>Datos consultados</Select.Option>
            <Select.Option value={1}>Archivo .csv revisado</Select.Option>
          </Select>
        </Form.Item>

        {modoCarga === 0 && (
          <Form.Item
            required
            label="Tipo de proveedor"
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: "250px" }}
              placeholder="Seleccione el tipo de proveedor..."
              onChange={(value) => setTipoProveedor(value)}
            >

            {proveedoresConsultaResponse.map((p) => (
              <Select.Option key={p.id} value={p.id}>
              {p.nombre}
            </Select.Option>
            ))}

            </Select>
          </Form.Item>
        )}

        <Form.Item label={`Archivo con datos de los titulares`}>
          <UploadContainer>
            <span>
              {!file ? "Arrastre el archivo o haga click aquí" : file.name}
            </span>
            <input
              ref={inputRef}
              onChange={(event) => {
                const file = event.target.files?.item(0);
                if (
                  file &&
                  !getAcceptedExtensions().includes(
                    `.${file.name.split(".").pop()}`
                  )
                ) {
                  return;
                }
                setFile(file);
              }}
              type="file"
              accept={getAcceptedExtensions().join(",")}
            />
          </UploadContainer>
        </Form.Item>
        <Button
          loading={loading}
          type="primary"
          disabled={!file || (!tipoProveedor && modoCarga == 0)}
          htmlType="submit"
        >
          Cargar consulta
        </Button>
      </Form>
    </MainLayout>
  );
};